var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled, { css } from 'styled-components';
import { Color } from '../const/';
var ToggleStateless = (function (_super) {
    __extends(ToggleStateless, _super);
    function ToggleStateless() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToggleStateless.prototype.handleChange = function (e) {
        if (this.props.onChange) {
            this.props.onChange(e);
        }
    };
    ToggleStateless.prototype.render = function () {
        var _this = this;
        var _a = this.props, name = _a.name, isChecked = _a.isChecked, isDisabled = _a.isDisabled, value = _a.value;
        return (React.createElement(Label, null,
            React.createElement(Input, { checked: isChecked, name: name, disabled: isDisabled, onChange: function (e) { return _this.handleChange(e); }, value: value }),
            React.createElement(Bar, { checked: isChecked, disabled: isDisabled },
                React.createElement(Handle, { checked: isChecked, disabled: isDisabled }))));
    };
    ToggleStateless.defaultProps = {
        onChange: function () { },
    };
    return ToggleStateless;
}(React.Component));
var Label = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n  height: 32px;\n  width: 52px;\n"], ["\n  display: inline-block;\n  position: relative;\n  height: 32px;\n  width: 52px;\n"])));
var Input = styled.input.attrs({
    type: 'checkbox',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  opacity: 0;\n  width: 0;\n  height: 0;\n  ", ";\n"], ["\n  opacity: 0;\n  width: 0;\n  height: 0;\n  ",
    ";\n"])), function (props) {
    return props.disabled && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      visibility: hidden;\n    "], ["\n      visibility: hidden;\n    "])));
});
var Bar = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  cursor: pointer;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  position: absolute;\n  background-color: ", ";\n  border-radius: 16px;\n  top: 0;\n  left: 0;\n  width: 52px;\n  height: 32px;\n  transition: all 0.2s;\n  ", ";\n"], ["\n  cursor: pointer;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  position: absolute;\n  background-color: ", ";\n  border-radius: 16px;\n  top: 0;\n  left: 0;\n  width: 52px;\n  height: 32px;\n  transition: all 0.2s;\n  ",
    ";\n"])), function (props) { return (props.checked ? Color.VIVID_BLUE : Color.GRAY); }, function (props) {
    return props.disabled && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      cursor: default;\n      opacity: 0.3;\n    "], ["\n      cursor: default;\n      opacity: 0.3;\n    "])));
});
var Handle = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: absolute;\n  background-color: ", ";\n  border-radius: 28px;\n  left: ", "!important;\n  width: 28px;\n  height: 28px;\n  margin: 2px;\n  transition: all 0.2s;\n  box-shadow: 0 6px 8px rgba(102, 119, 136, 0.03),\n    0 1px 2px rgba(102, 119, 136, 0.3);\n"], ["\n  position: absolute;\n  background-color: ", ";\n  border-radius: 28px;\n  left: ", "!important;\n  width: 28px;\n  height: 28px;\n  margin: 2px;\n  transition: all 0.2s;\n  box-shadow: 0 6px 8px rgba(102, 119, 136, 0.03),\n    0 1px 2px rgba(102, 119, 136, 0.3);\n"])), Color.WHITE, function (props) { return (props.checked ? '20px' : '0'); });
export default ToggleStateless;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=toggle-stateless.js.map